import { Octokit } from "octokit";
import { useEffect, useState } from "react";

import "./App.css";
import UserPage from "./pages/User";
import { micahstubbsGists } from "./micahstubbsGists";

function App() {
  const userId = window.location.href && window.location.href.split("/")[3];
  console.log("userId", userId);

  const [gists, setGists] = useState<any>([]);

  const octokit = new Octokit({});

  const getGists = async () => {
    // read local storage
    const localGists = localStorage.getItem(`users/${userId}/gists`);
    if (localGists) {
      setGists(JSON.parse(localGists));

      // if the gists updated timestamp is less than 5 minutes ago, then return
      const gistsUpdated = localStorage.getItem(`users/${userId}/gistsUpdated`);
      if (gistsUpdated && new Date().getTime() - new Date(gistsUpdated).getTime() < 5 * 60 * 1000) {
        return;
      }

      return;
    }

    if (userId === "micahstubbs") {
      setGists(micahstubbsGists);
      return;
    }



    // get a list of all of that user's gists
    // from the github api
    const remoteGists = await octokit.paginate(`GET /users/${userId}/gists`, {
      per_page: 100,
      // headers: {
      //   "X-GitHub-Api-Version": "2022-11-28",
      // },
    });

    if (remoteGists && remoteGists.length > 0) {
      // write gists to local storage
      localStorage.setItem(`users/${userId}/gists`, JSON.stringify(gists));
          // write the gists updated timestamp per user to local storage
    localStorage.setItem(`users/${userId}/gistsUpdated`, new Date().toISOString());
    }

    console.log("remoteGists", remoteGists);
    setGists(remoteGists);
  };

  useEffect(() => {
    getGists();
  }, []);

  useEffect(() => {
    
    if (gists && gists.length > 0) {
      
    }
  }, [gists]);

  // // get a list of all of that user's gists
  // fetch(`https://api.github.com/users/${userId}/gists`)
  //   .then((response) => response.json())
  //   .then((data) => {
  //     console.log("data", data);
  //   });
  console.log("gist", gists[0]);

  return (
    <div className="App">
      <UserPage gists={gists} userId={userId} showHeader={false} showFooter={false} />
    </div>
  );
}

export default App;
